var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-drawer",
    {
      attrs: {
        size: _vm.size,
        "destroy-on-close": "",
        "append-to-body": "",
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c("yxt-user-selector", {
        ref: "selector",
        attrs: {
          data: _vm.users,
          limit: 30,
          tabs: _vm.tabs,
          enableGroupCorp: !!_vm.groupOrgFlag,
          dataPermissionCode: _vm.groupOrgFlag
            ? _vm.groupDataPermissionCode
            : _vm.dataPermissionCode,
          functionCode: _vm.groupOrgFlag
            ? _vm.groupFunctionCode
            : _vm.functionCode,
        },
      }),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "yxt-button",
            { attrs: { plain: "" }, on: { click: _vm.cancelUser } },
            [_vm._v(_vm._s(_vm.$t("pc_ulcd_btn_cancel")))]
          ),
          _c(
            "yxt-button",
            { attrs: { type: "primary" }, on: { click: _vm.getUsers } },
            [_vm._v(_vm._s(_vm.$t("pc_ulcd_btn_done")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }